<ng-container *ngIf="squad_group$ | async as squad_group">
  {{squad_group.name}}
</ng-container>
